<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/final-gaji-list-draft">Daftar Gaji</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Rekap Gaji</li>
      </ol>
    </nav>

    <h5 class="content-block">Rekap Gaji</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Peraturan Rekap Gaji</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="settingSource"
                valueExpr="val"
                displayExpr="text"
                width="100%"
                label="Periode rekap"
                placeholder="Periode rekap"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="setting"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="validateFilter"
                text="Lihat Rekap Gaji"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDireksi>
            <DxPivotGrid
              id="pivotDireksi"
              ref="pivotDireksiRef"
              :allow-sorting-by-summary="true"
              :allow-sorting="true"
              :allow-filtering="true"
              :allow-expand-all="true"
              :show-borders="true"
              :data-source="dataSourceDireksi"
              @exporting="onExporting"
            >
              <DxFieldChooser :enabled="false" />
              <DxExport :enabled="true" />
            </DxPivotGrid>
          </template>
          <template #tTetap>
            <DxPivotGrid
              id="pivotTetap"
              :allow-sorting-by-summary="true"
              :allow-sorting="true"
              :allow-filtering="true"
              :allow-expand-all="true"
              :show-borders="true"
              :data-source="dataSourceTetap"
              @exporting="onExporting"
            >
              <DxFieldChooser :enabled="false" />
              <DxExport :enabled="true" />
            </DxPivotGrid>
          </template>
          <template #tHonor>
            <DxPivotGrid
              id="pivotHonor"
              :allow-sorting-by-summary="true"
              :allow-sorting="true"
              :allow-filtering="true"
              :allow-expand-all="true"
              :show-borders="true"
              :data-source="dataSourceHonor"
              @exporting="onExporting"
            >
              <DxFieldChooser :enabled="false" />
              <DxExport :enabled="true" />
            </DxPivotGrid>
          </template>
          <template #tKontrak>
            <DxPivotGrid
              id="pivotKontrak"
              :allow-sorting-by-summary="true"
              :allow-sorting="true"
              :allow-filtering="true"
              :allow-expand-all="true"
              :show-borders="true"
              :data-source="dataSourceKontrak"
              @exporting="onExporting"
            >
              <DxFieldChooser :enabled="false" />
              <DxExport :enabled="true" />
            </DxPivotGrid>
          </template>
        </DxTabPanel>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import DxTabPanel from "devextreme-vue/tab-panel";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import DxPivotGrid, {
  DxExport,
  DxFieldChooser,
} from "devextreme-vue/pivot-grid";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { exportPivotGrid } from "devextreme/excel_exporter";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import DxSelectBox from "devextreme-vue/select-box";

const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 4,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
];

const settingSource = [
  {
    id: 1,
    text: "Bulan ini",
    val: "0",
  },
  {
    id: 2,
    text: "Tahun ini",
    val: "tahun",
  },
  {
    id: 3,
    text: "Tahun lalu",
    val: "tahunlalu",
  },
  {
    id: 4,
    text: "3 bulan terakhir",
    val: "3",
  },
  {
    id: 5,
    text: "12 bulan terakhir",
    val: "12",
  },
  {
    id: 6,
    text: "3 tahun terakhir",
    val: "36",
  },
];

export default {
  components: {
    DxTabPanel,
    DxExport,
    DxPivotGrid,
    DxFieldChooser,
    DxValidator,
    DxRequiredRule,
    DxButton,
    DxSelectBox,
  },
  data() {
    return {
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      setting: "0",
      settingSource: settingSource,
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,
      tabSource: tabSource,
      //---PIVOT
      storeKontrak: null,
      dataSourceKontrak: null,
      storeHonor: null,
      dataSourceHonor: null,
      storeTetap: null,
      dataSourceTetap: null,
      storeDireksi: null,
      dataSourceDireksi: null,
      //---/PIVOT
    };
  },
  async mounted() {
    this.storeDireksi = await this.fetchData(1);
    console.log("direksi", this.storeDireksi);
    this.setDataStoreDireksi();

    this.storeTetap = await this.fetchData(2);
    console.log("tetap", this.storeTetap);
    this.setDataStoreTetap();

    this.storeHonor = await this.fetchData(3);
    this.setDataStoreHonor();
    console.log("honor", this.storeHonor);

    this.storeKontrak = await this.fetchData(4);
    console.log("kontrak", this.storeKontrak);
    this.setDataStoreKontrak();

    // const pivotGrid = this.$refs.pivotDireksiRef;
    // console.log("element", pivotGrid);
    // console.log("expl", pivotGrid.dataSource);

    // const ds = pivotGrid.dataSource;
    // console.log("ds", ds);
    // console.log("instance datasource", instance.dataSource);
  },
  methods: {
    setDataStoreKontrak() {
      this.dataSourceKontrak = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Honor",
            dataField: "honor_umk_jml",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "KMK",
            dataField: "kenaikan_masa_kerja",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml tdk hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tun. BPJS TK",
            dataField: "tun_bpjs_tk_satu_sembilanbelas_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJSK TK",
            dataField: "pot_bpjs_tk_satu_sembilanbelas_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total Diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeKontrak,
      });
    },
    setDataStoreHonor() {
      this.dataSourceHonor = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Honor",
            dataField: "honor_umk_jml",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "KMK",
            dataField: "kenaikan_masa_kerja",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml tdk hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJSK TK",
            dataField: "pot_bpjs_tk_dua_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeHonor,
      });
    },
    setDataStoreTetap() {
      this.dataSourceTetap = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Gapok",
            dataField: "gaji_pokok",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },

          {
            caption: "Tunj. Perusahaan",
            dataField: "tun_perusahaan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Jabatan",
            dataField: "tun_jabatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kemahalan",
            dataField: "tun_kemahalan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Air",
            dataField: "tun_air",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Transport",
            dataField: "tun_transport",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Pangan",
            dataField: "tun_pangan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Tdk Hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. PPH",
            dataField: "tun_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 3",
            dataField: "pot_bpjs_tk_tiga_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 4",
            dataField: "pot_bpjs_tk_empat_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Pensiun Jiwasraya",
            dataField: "pot_pensiun",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. PPH",
            dataField: "pot_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total Diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeTetap,
      });
    },
    setDataStoreDireksi() {
      this.dataSourceDireksi = new PivotGridDataSource({
        fields: [
          {
            caption: "Cabang",
            width: 120,
            dataField: "cabang",
            area: "row",
          },
          {
            dataField: "tgl",
            dataType: "date",
            area: "column",
          },
          {
            caption: "Gapok",
            dataField: "gaji_pokok",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },

          {
            caption: "Tunj. Perusahaan",
            dataField: "tun_perusahaan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Jabatan",
            dataField: "tun_jabatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kemahalan",
            dataField: "tun_kemahalan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Air",
            dataField: "tun_air",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Transport",
            dataField: "tun_transport",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Pangan",
            dataField: "tun_pangan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. Kesehatan",
            dataField: "tun_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Tdk Hadir",
            dataField: "jml_tdk_hadir",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Tdk Hadir",
            dataField: "pot_5_persen",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Jml Bruto",
            dataField: "jml_bruto",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Tunj. PPH",
            dataField: "tun_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Kesehatan",
            dataField: "pot_kesehatan",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 3",
            dataField: "pot_bpjs_tk_tiga_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. BPJS TK 4",
            dataField: "pot_bpjs_tk_empat_program",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. Pensiun Jiwasraya",
            dataField: "pot_pensiun",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Pot. PPH",
            dataField: "pot_pph",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
          {
            caption: "Total Diterima",
            dataField: "total_diterima",
            dataType: "number",
            summaryType: "sum",
            format: "#,##0",
            area: "data",
          },
        ],
        store: this.storeDireksi,
      });
    },

    async validateFilter(e) {
      const result = e.validationGroup.validate();

      if (!result.isValid) return 0;
      this.storeDireksi = await this.fetchData(1);
      this.setDataStoreDireksi();

      this.storeTetap = await this.fetchData(2);
      this.setDataStoreTetap();

      this.storeHonor = await this.fetchData(3);
      this.setDataStoreHonor();

      this.storeKontrak = await this.fetchData(4);
      this.setDataStoreKontrak();

      // this.storeTetap = await this.fetchData(2);
      // this.storeHonor = await this.fetchData(3);
      // this.storeKontrak = await this.fetchData(4);

      // console.log("refresh direksi", this.storeDireksi);
      // // console.log("refresh tetap", this.storeTetap);
      // // console.log("refresh honor", this.storeHonor);
      // // console.log("refresh kontrak", this.storeKontrak);
      // const pivotGrid = this.$refs.pivotDireksiRef.instance;
      // console.log("element", pivotGrid);
      // const ds = pivotGrid.getDataSource();
      // console.log("ds", ds);
      // pivotGrid.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Rekap Gaji");

      exportPivotGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Rekap Gaji.xlsx"
          );
        });
      });
      e.cancel = true;
    },

    async fetchData(pegawaiStatusId) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        pegawai_status_id: pegawaiStatusId,
        tgl_gaji_setting: this.setting,
      };
      const response = await axios.post(
        `${API_BASE_URL}/rekap_gaji_pivot`,
        data,
        config
      );
      return response.data[0];
    },
  },
};
</script>
